import { UseControllerProps } from 'react-hook-form';

import { SubscriptionPlanType } from '../../../../common/interfaces/entities';

export const SubscriptionAssistanceRequestType = {
  PLATFORM_AND_SUBSCRIPTION_USAGE: 'PLATFORM_AND_SUBSCRIPTION_USAGE',
  SUBSCRIPTION_PLAN_RENEWAL: 'SUBSCRIPTION_PLAN_RENEWAL',
  SUBSCRIPTION_PLAN_UPGRADE: 'SUBSCRIPTION_PLAN_UPGRADE',
  CONSULTATION: 'CONSULTATION',
  COMPANY_VERIFICATION: 'COMPANY_VERIFICATION',
  TALENT_SEARCH_CHAT_ADDITION: 'TALENT_SEARCH_CHAT_ADDITION',
  OTHER: 'OTHER',
} as const;

export type SubscriptionAssistanceRequestType =
  (typeof SubscriptionAssistanceRequestType)[keyof typeof SubscriptionAssistanceRequestType];

export type SubscriptionAssistanceFormDataType = {
  firstName: string;
  lastName?: string;
  email: string;
  phoneNumber: string;
  requestType: SubscriptionAssistanceRequestType;
  planType?: SubscriptionPlanType;
  notes?: string;
};

export type SubscriptionAssistanceFormFieldNames =
  UseControllerProps<SubscriptionAssistanceFormDataType>['name'];

export type SubscriptionPlansOption = {
  planType: SubscriptionPlanType;
  translatedPlanName: string;
};
